import type { NDateLocale } from './enUS'
import { enUS } from 'date-fns/locale'

const dateSiLK: NDateLocale = {
  name: 'si-LK',
  locale: enUS
}

export default dateSiLK
